<style scoped>
    .view-item{
        display: inline-block;
        cursor: pointer;
    }
</style>
<template>
  <div class="view-item">
    <Tooltip
      v-if="tip"
      placement="top"
    >
      <div @click="showItem">
        <slot />
      </div>
      <div slot="content">
        点击查看
      </div>
    </Tooltip>
    <div
      v-else
      @click="showItem"
    >
      <slot />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      model_id: {
        type: Number
      },
      type: {
        type: String,
        /* 
          Contract 合同,
          MallOnlineItem  商品上架详情
          Stock 存货详情
          StockCalculator 存货选择
          ExpenseGroup 付款
          ReceiptDocumentRelations
          OutsourceContract 兼职外包合同
          BankStatementRelations 流水记录等
          Invoice 发票详情
          Wiki
          RecAwardTopic 实习生推荐奖详情
          RecruitNeed 职位申请详情
        */
      },
      tip: {
        type: Boolean,
        default: true
      },
      show_type: {
        type: String,
        default: 'viewer'
      },
      receipt_type: {
        type: String,
      },
      viewerParams: {
        type: Object,
      }
    },
    methods: {
      showItem() {
        if (this.show_type === 'drawer') {
          this.showDrawer();
        } else {
          this.showViewer();
        }
      },
      showDrawer() {
        window.eventHub.$emit('drawer-show', this.model_id, this.type)
      },
      showViewer() {
        window.eventHub.$emit('viewer-show', this.model_id, this.type, this.receipt_type, this.viewerParams)
      }
    }
  }
</script>
